import admin from './admin';
import deleteMessages from './deleteMessages';
import reactToMessages from './reactToMessages';
import replyToMessages from './replyToMessages';
import sendMessages from './sendMessages';
import update from './update';
import view from './view';

export default {
	// namespaced: true,
	modules: {
		admin, deleteMessages, reactToMessages, replyToMessages, sendMessages, update, view
	}
}
